<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <h1>Características do Acolhido</h1>
                </div>
            </div>
            <b-tabs content-class="mt-3">
                <b-tab title="Saúde e Desenvolvimento" active>
                    <Saude :item="item" @submit="submit" />
                </b-tab>
                <b-tab title="Educação">
                    <Educacao :item="item" @submit="submit" />
                </b-tab>
                <b-tab title="Trabalho e Renda">
                    <Profissional :item="item" @submit="submit" />
                </b-tab>
                <b-tab title="Aspecto Gerais">
                    <AspectoGerais :item="item" @submit="submit" />
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>
<script>
import Saude from "./CaracteristicaSaude";
import Educacao from "./CaracteristicaEducacao";
import Profissional from "./CaracteristicaProfissional";
import AspectoGerais from "./CaracteristicaAspectoGerais";
export default {
    components: { Saude, Educacao, Profissional, AspectoGerais },
    props: ["item"],
    data() {
        return {};
    },
    methods: {
        submit() {
            this.$emit("submit");
        }
    }
};
</script>
